export default {"src":"/_next/static/media/import.eb3d2bf5.svg","height":80,"width":80};